module.exports = __webpack_public_path__ + "static/hero-advertorial-029585f471a0522af04de7be205b5dec.png";